<script setup lang="ts">
import { possessive } from '@/helpers/format';
import type { Applicant, ApplicantId, AssetId, PropertyId, PropertyOwnership } from '@/types';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    data: PropertyOwnership[];
    properties: Record<PropertyId | AssetId, string>;
    applicants: Record<ApplicantId, Applicant>;
    isErhl?: boolean;
  }>(),
  {
    isErhl: false,
  },
);

const propertyOwnerships = computed(() =>
  props.data.filter((ownership) => {
    if (ownership.type === 'asset') return false;
    if (props.isErhl && ownership.type === 'outgoing') return false;
    return true;
  }),
);

const ownershipHeading = (type: PropertyOwnership['type'], address: string): string => {
  const label = type === 'incoming' ? 'Buying' : props.isErhl && type === 'supporting' ? 'Properties' : 'Selling';
  return `${label} - ${address}`;
};
</script>

<template>
  <section class="summary-details">
    <h2>Property ownership</h2>
    <template v-for="item in propertyOwnerships" :key="item.id">
      <h3>{{ ownershipHeading(item.type, properties[item.id]) }}</h3>
      <dl>
        <template v-for="(value, applicantId) in item.share" :key="applicantId">
          <dt>{{ possessive(applicants[applicantId]?.preferredName) }} share</dt>
          <dd>{{ value }}%</dd>
        </template>
      </dl>
    </template>
  </section>
</template>
